"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ml/testing/ml-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fml%2Ftesting%2Fml-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.mlServiceOperationToJSON = exports.mlServiceOperationFromJSON = exports.GetTestUserResponse = exports.GetTestUserRequest = exports.UpdateTestUserResponse = exports.UpdateTestUserRequest = exports.CreditReportFeatures = exports.TestUserData = exports.MlServiceOperation = void 0;
const payment_features_1 = require("../../feature-store/payment-features");
const user_features_1 = require("../../feature-store/user-features");
const protobufPackage = 'com.step.ml.internal.proto';
var MlServiceOperation;
(function (MlServiceOperation) {
    MlServiceOperation["INVALID_SANDBOX_OPERATION"] = "INVALID_SANDBOX_OPERATION";
    MlServiceOperation["EVALUATE_USER"] = "EVALUATE_USER";
    MlServiceOperation["EVALUATE_TRANSACTION"] = "EVALUATE_TRANSACTION";
    MlServiceOperation["EVALUATE_LENDING_RISK"] = "EVALUATE_LENDING_RISK";
    MlServiceOperation["EVALUATE_LENDING_FRAUD"] = "EVALUATE_LENDING_FRAUD";
    MlServiceOperation["EVALUATE_ACH_OUT_TRANSACTION"] = "EVALUATE_ACH_OUT_TRANSACTION";
    MlServiceOperation["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MlServiceOperation || (exports.MlServiceOperation = MlServiceOperation = {}));
function createBaseTestUserData() {
    return {
        bypassSandbox: undefined,
        bypassSandboxOperations: [],
        userLevelFeatures: undefined,
        rollingPaymentFeatures: undefined,
        creditReportFeatures: undefined,
    };
}
exports.TestUserData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.bypassSandbox)) {
            message.bypassSandbox = globalThis.Boolean(object.bypassSandbox);
        }
        if (globalThis.Array.isArray(object?.bypassSandboxOperations)) {
            message.bypassSandboxOperations = object.bypassSandboxOperations.map((e) => mlServiceOperationFromJSON(e));
        }
        if (isSet(object.userLevelFeatures)) {
            message.userLevelFeatures = user_features_1.UserLevelFeatures.fromJSON(object.userLevelFeatures);
        }
        if (isSet(object.rollingPaymentFeatures)) {
            message.rollingPaymentFeatures = payment_features_1.RollingPaymentFeatures.fromJSON(object.rollingPaymentFeatures);
        }
        if (isSet(object.creditReportFeatures)) {
            message.creditReportFeatures = exports.CreditReportFeatures.fromJSON(object.creditReportFeatures);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bypassSandbox !== undefined) {
            obj.bypassSandbox = message.bypassSandbox;
        }
        if (message.bypassSandboxOperations?.length) {
            obj.bypassSandboxOperations = message.bypassSandboxOperations.map((e) => mlServiceOperationToJSON(e));
        }
        if (message.userLevelFeatures !== undefined) {
            obj.userLevelFeatures = user_features_1.UserLevelFeatures.toJSON(message.userLevelFeatures);
        }
        if (message.rollingPaymentFeatures !== undefined) {
            obj.rollingPaymentFeatures = payment_features_1.RollingPaymentFeatures.toJSON(message.rollingPaymentFeatures);
        }
        if (message.creditReportFeatures !== undefined) {
            obj.creditReportFeatures = exports.CreditReportFeatures.toJSON(message.creditReportFeatures);
        }
        return obj;
    },
    create(base) {
        return exports.TestUserData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestUserData();
        message.bypassSandbox = object.bypassSandbox ?? undefined;
        message.bypassSandboxOperations = object.bypassSandboxOperations?.map((e) => e) || [];
        message.userLevelFeatures =
            (object.userLevelFeatures !== undefined && object.userLevelFeatures !== null)
                ? user_features_1.UserLevelFeatures.fromPartial(object.userLevelFeatures)
                : undefined;
        message.rollingPaymentFeatures =
            (object.rollingPaymentFeatures !== undefined && object.rollingPaymentFeatures !== null)
                ? payment_features_1.RollingPaymentFeatures.fromPartial(object.rollingPaymentFeatures)
                : undefined;
        message.creditReportFeatures =
            (object.creditReportFeatures !== undefined && object.creditReportFeatures !== null)
                ? exports.CreditReportFeatures.fromPartial(object.creditReportFeatures)
                : undefined;
        return message;
    },
};
function createBaseCreditReportFeatures() {
    return {
        creditScore: 0,
        subjectNameCount: 0,
        subjectAddressCount: 0,
        subjectEmploymentCount: 0,
        creditTradeCount: 0,
        creditAccountHistoryCount: 0,
        creditCollectionCount: 0,
        creditInquiryCount: 0,
    };
}
exports.CreditReportFeatures = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditScore)) {
            message.creditScore = globalThis.Number(object.creditScore);
        }
        if (isSet(object.subjectNameCount)) {
            message.subjectNameCount = globalThis.Number(object.subjectNameCount);
        }
        if (isSet(object.subjectAddressCount)) {
            message.subjectAddressCount = globalThis.Number(object.subjectAddressCount);
        }
        if (isSet(object.subjectEmploymentCount)) {
            message.subjectEmploymentCount = globalThis.Number(object.subjectEmploymentCount);
        }
        if (isSet(object.creditTradeCount)) {
            message.creditTradeCount = globalThis.Number(object.creditTradeCount);
        }
        if (isSet(object.creditAccountHistoryCount)) {
            message.creditAccountHistoryCount = globalThis.Number(object.creditAccountHistoryCount);
        }
        if (isSet(object.creditCollectionCount)) {
            message.creditCollectionCount = globalThis.Number(object.creditCollectionCount);
        }
        if (isSet(object.creditInquiryCount)) {
            message.creditInquiryCount = globalThis.Number(object.creditInquiryCount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditScore !== undefined && message.creditScore !== 0) {
            obj.creditScore = Math.round(message.creditScore);
        }
        if (message.subjectNameCount !== undefined && message.subjectNameCount !== 0) {
            obj.subjectNameCount = Math.round(message.subjectNameCount);
        }
        if (message.subjectAddressCount !== undefined && message.subjectAddressCount !== 0) {
            obj.subjectAddressCount = Math.round(message.subjectAddressCount);
        }
        if (message.subjectEmploymentCount !== undefined && message.subjectEmploymentCount !== 0) {
            obj.subjectEmploymentCount = Math.round(message.subjectEmploymentCount);
        }
        if (message.creditTradeCount !== undefined && message.creditTradeCount !== 0) {
            obj.creditTradeCount = Math.round(message.creditTradeCount);
        }
        if (message.creditAccountHistoryCount !== undefined && message.creditAccountHistoryCount !== 0) {
            obj.creditAccountHistoryCount = Math.round(message.creditAccountHistoryCount);
        }
        if (message.creditCollectionCount !== undefined && message.creditCollectionCount !== 0) {
            obj.creditCollectionCount = Math.round(message.creditCollectionCount);
        }
        if (message.creditInquiryCount !== undefined && message.creditInquiryCount !== 0) {
            obj.creditInquiryCount = Math.round(message.creditInquiryCount);
        }
        return obj;
    },
    create(base) {
        return exports.CreditReportFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditReportFeatures();
        message.creditScore = object.creditScore ?? 0;
        message.subjectNameCount = object.subjectNameCount ?? 0;
        message.subjectAddressCount = object.subjectAddressCount ?? 0;
        message.subjectEmploymentCount = object.subjectEmploymentCount ?? 0;
        message.creditTradeCount = object.creditTradeCount ?? 0;
        message.creditAccountHistoryCount = object.creditAccountHistoryCount ?? 0;
        message.creditCollectionCount = object.creditCollectionCount ?? 0;
        message.creditInquiryCount = object.creditInquiryCount ?? 0;
        return message;
    },
};
function createBaseUpdateTestUserRequest() {
    return { userId: '', user: undefined };
}
exports.UpdateTestUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.user)) {
            message.user = exports.TestUserData.fromJSON(object.user);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.user !== undefined) {
            obj.user = exports.TestUserData.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateTestUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTestUserRequest();
        message.userId = object.userId ?? '';
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.TestUserData.fromPartial(object.user)
            : undefined;
        return message;
    },
};
function createBaseUpdateTestUserResponse() {
    return {};
}
exports.UpdateTestUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateTestUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateTestUserResponse();
        return message;
    },
};
function createBaseGetTestUserRequest() {
    return { userId: '' };
}
exports.GetTestUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.GetTestUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTestUserRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseGetTestUserResponse() {
    return { user: undefined };
}
exports.GetTestUserResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.user)) {
            message.user = exports.TestUserData.fromJSON(object.user);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = exports.TestUserData.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.GetTestUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTestUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.TestUserData.fromPartial(object.user)
            : undefined;
        return message;
    },
};
function mlServiceOperationFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SANDBOX_OPERATION':
            return MlServiceOperation.INVALID_SANDBOX_OPERATION;
        case 1:
        case 'EVALUATE_USER':
            return MlServiceOperation.EVALUATE_USER;
        case 2:
        case 'EVALUATE_TRANSACTION':
            return MlServiceOperation.EVALUATE_TRANSACTION;
        case 3:
        case 'EVALUATE_LENDING_RISK':
            return MlServiceOperation.EVALUATE_LENDING_RISK;
        case 4:
        case 'EVALUATE_LENDING_FRAUD':
            return MlServiceOperation.EVALUATE_LENDING_FRAUD;
        case 5:
        case 'EVALUATE_ACH_OUT_TRANSACTION':
            return MlServiceOperation.EVALUATE_ACH_OUT_TRANSACTION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MlServiceOperation.UNRECOGNIZED;
    }
}
exports.mlServiceOperationFromJSON = mlServiceOperationFromJSON;
function mlServiceOperationToJSON(object) {
    switch (object) {
        case MlServiceOperation.INVALID_SANDBOX_OPERATION:
            return 'INVALID_SANDBOX_OPERATION';
        case MlServiceOperation.EVALUATE_USER:
            return 'EVALUATE_USER';
        case MlServiceOperation.EVALUATE_TRANSACTION:
            return 'EVALUATE_TRANSACTION';
        case MlServiceOperation.EVALUATE_LENDING_RISK:
            return 'EVALUATE_LENDING_RISK';
        case MlServiceOperation.EVALUATE_LENDING_FRAUD:
            return 'EVALUATE_LENDING_FRAUD';
        case MlServiceOperation.EVALUATE_ACH_OUT_TRANSACTION:
            return 'EVALUATE_ACH_OUT_TRANSACTION';
        case MlServiceOperation.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.mlServiceOperationToJSON = mlServiceOperationToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=ml-testing-service.js.map